import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./App.css";
import Navbar from "./Navbar";
import FlightHome from "./FlightSearch";
import FeaturesSection from "./FeatureSection";
import FlightDestinations from "./FlightDestinations";
import AboutUsSection from "./AboutSection";
import FeaturedAirlines from "./FeaturedAirline";
import ClientReviews from "./ClientReviews";
import Footer from "./Footer";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import CallUsBanner from "./CallUsBanner";


function Home() {
  return (
    <div className="App">
      <FlightHome />
      <FeaturesSection />
      <FlightDestinations />
      <AboutUsSection />
      <FeaturedAirlines />
      <ClientReviews />
    </div>
  );
}

export default Home;
